
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class SummaryStep extends Vue {
  @Prop({ type: Array, required: true }) readonly products!: any[]

  @Prop({ type: Object, required: true }) readonly totalSkuAndTotalQty!: any
}
